import { useMemo } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { breakpoints, Button, Heading, Inline, PageBlock, Text, textVariants, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { STEP_INDICATOR_HEIGHT } from '../constants/modal';
import { getOriginDestinationCities } from '../utils/segmentUtils';
import UnavailableCard from './UnavailableCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const headingStyles = css`
  padding: 16px 0;
`;
const segmentHeaderStyles = css`
  background: ${vars.colors.surface.primary};
  box-shadow: 0 2px 4px 0 #0000000d;
  padding: 16px;
  position: sticky;
  top: calc(var(--header-offset, 0) + ${STEP_INDICATOR_HEIGHT}px);
  transition: top 0.2s ease-in-out;
  z-index: 1;
`;
const contentWrapperStyles = css`
  margin-bottom: 16px;

  @media (min-width: ${breakpoints._768}) {
    border-radius: ${vars.card.borderRadius};
    box-shadow: 0 2px 12px rgb(0 0 0 / 5%);
    margin-bottom: 40px;
    overflow: clip;
  }
`;
const contentStyles = {
  base: css`
    padding: 0 16px 56px;
  `,
  centered: css`
    place-content: center;
  `,
  minHeight: css`
    min-height: calc(100vh - 413px);

    @media (min-width: ${breakpoints._768}) {
      min-height: calc(100vh - 401px);
    }

    @media (min-width: ${breakpoints._1440}) {
      min-height: calc(100vh - 320px);
    }
  `,
  pageBackground: css`
    background-color: ${vars.colors.page.background.primary};
  `
};
const footerStyles = css`
  background: ${vars.colors.surface.primary};
  bottom: 0;
  box-shadow: 0 -2px 8px 0 #0000000d;
  display: flex;
  justify-content: end;
  padding: 8px 16px;
  position: sticky;
  transition: padding-bottom 0.2s ease;
  width: 100%;
`;
const footerButtonStyles = css`
  flex: 1;

  @media (min-width: ${breakpoints._768}) {
    flex: initial;
    min-width: 120px;
  }
`;
const SeatMapUnavailable = ({
  bounds = [],
  onClick
}) => {
  const {
    t
  } = useTranslation();
  const isTabletOrAboveViewport = useMediaQuery(`(min-width: ${breakpoints._768})`);
  const headerCities = useMemo(() => getOriginDestinationCities(bounds), [bounds]);
  const toLabel = String(t('ScreenReader.To.AriaLabel.Text')).toLowerCase();
  const Wrapper = isTabletOrAboveViewport ? PageBlock : 'div';
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(Heading, {
      className: headingStyles,
      level: 1,
      children: t('Product.SeatMap.Header.Label')
    }), /*#__PURE__*/_jsxs("div", {
      className: contentWrapperStyles,
      children: [headerCities.from && headerCities.to && /*#__PURE__*/_jsx(Inline, {
        className: segmentHeaderStyles,
        children: /*#__PURE__*/_jsxs(Text, {
          "aria-label": `${headerCities.from} ${toLabel} ${headerCities.to}`,
          variant: textVariants._16_BOLD,
          children: [headerCities.from, " \u2013 ", headerCities.to]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cx(contentStyles.base, contentStyles.centered, contentStyles.minHeight, contentStyles.pageBackground),
        children: /*#__PURE__*/_jsx(UnavailableCard, {})
      }), /*#__PURE__*/_jsx("footer", {
        className: footerStyles,
        "data-testid": "seatMapFooter",
        children: /*#__PURE__*/_jsx(Button, {
          className: footerButtonStyles,
          "data-testid": "saveAndContinue-button",
          onClick: onClick,
          type: "button",
          variant: "primary",
          children: t('Product.Bundle.Confirm.Button.Text')
        })
      })]
    })]
  });
};
export default SeatMapUnavailable;
//# sourceMappingURL=SeatMapUnavailable.js.map